export default __webpack_public_path__ + "static/media/manage.4ba06764.svg";